export function songList(payload) {
  return {
    type: "SONGS",
    payload,
  };
}

export function addSongAction(payload, playListId, isQueue, albumId) {
  return {
    type: "ADD_SONG",
    payload,
    playListId, //for add streaming purpose to check if its a plalist song
    isQueue, //add to queue if true otherwise play the song
    albumId,
  };
}
export function addSongsAction(payload, isMore, playListId, index, albumId) {
  return {
    type: "ADD_SONGS",
    payload,
    isMore,
    playListId,
    index,
    albumId,
  };
}
export function addSongIndexAction(payload) {
  return {
    type: "ADD_SONG_INDEX",
    payload,
  };
}

export function clearSong(payload) {
  return {
    type: "CLEAR",
    payload,
  };
}
export function removeSong(payload) {
  return {
    type: "REMOVE",
    payload,
  };
}
